//Models
PJQ.models.commitments.ChangeOrder = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        arr.push({
            endpoint: 'commitmentchangeorders',
            value: this.id
        });
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    },
    parse: function (model) {
        if (!model)
            return model;

        if (model.commitment) {
            this.commitment = model.commitment;
        }

        this.lineItems = new PJQ.collections.commitments.ChangeOrderLineItems(model.lineItems);
        this.attachments = new PJQ.collections.commitments.ChangeOrderAttachments(model.attachments);
        this.invoices = new PJQ.collections.invoicing.PayableInvoices(model.invoices);

        this.markupItems = new PJQ.financialMarkups.collections.FinancialMarkups(model ? model.markupItems : null);

        if (model && model.contractedContact) {
            if (model.contractedContact instanceof PJQ.models.BaseModel) {
                this.contractedContact = model.contractedContact;
            } else {
                this.contractedContact = new PJQ.models.contacts.Contact(model.contractedContact);
            }
        }

        if (model && model.reviewer) {
            if (model.reviewer instanceof PJQ.models.BaseModel) {
                this.reviewer = model.reviewer;
            } else {
                this.reviewer = new PJQ.models.contacts.Contact(model.reviewer);
            }
        }

        if (model && model.receivedFrom) {
            if (model.receivedFrom instanceof PJQ.models.BaseModel) {
                this.receivedFrom = model.receivedFrom;
            } else {
                this.receivedFrom = new PJQ.models.contacts.Contact(model.receivedFrom);
            }
        }

        return model;
    },
    beforeSave: function () {
        let newMarkupLines = this.lineItems.filter(function (lineItem) {
            return lineItem.markup && lineItem.isNew();
        });
        this.lineItems.remove(newMarkupLines);

        this.set({
            lineItems: this.lineItems.toJSON(),
            attachments: this.attachments.toJSON(),
            markupItems: this.markupItems.toJSON()
        });
    },
    submit: function (signature, callback) {
        this.beforeSave();
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/submit',
            isAPIv2: true,
            data: this.toJSON()
        }).post().done(_.bind(function (response) {
            if (typeof callback === 'function') {
                this.set(this.parse(response));
                callback(true);
            }
        }, this)).fail(_.bind(function (response) {
            if (typeof callback === 'function') {
                callback(false);
            }
        }, this));
    },
    syncERP: function (callback) {
        return PJQ.models.commitments.Commitment.prototype.syncERP.call(this, callback);
    },
    unlinkERP: function (callback) {
        return PJQ.models.commitments.Commitment.prototype.unlinkERP.call(this, callback);
    },
    makeERPUrl: function (integration) {
        return PJQ.models.commitments.Commitment.prototype.makeERPUrl.call(this, integration);
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    getSubTotal: function () {
        return this.get('amount') + this.get('markupAmount');
    },
    getGrandTotal: function () {
        return this.getSubTotal() + this.get('taxAmount');
    }
});

PJQ.models.commitments.ChangeOrderHistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'submit': 'Submitted',
        'email': 'Email Sent'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.commitments.changeOrderStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.commitments.changeOrderStatusNames[toStatus];
            case 'email':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.commitments.ChangeOrderLineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.commitments.ChangeOrderAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.commitments.ChangeOrderCustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.commitments.ChangeOrderSettings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitmentchangeorders'
                },
                {
                    endpoint: 'settings'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.commitments.ChangeOrderUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.commitments.ChangeOrderFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'commitmentchangeorders'
            }
        ]);
    }
});

//Collections
PJQ.collections.commitments.ChangeOrders = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrder,
    endpoint: function () {
        let params = [];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'commitmentchangeorders'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        _.each(PJQ.constants.commitments.changeOrderStatusBuckets, function (bucket) {
            let total = 0;
            _.each(this.models, function (commitment) {
                if (bucket.statuses.indexOf(commitment.get('statusId')) !== -1) {
                    total += commitment.get('amount');
                }
            });
            result[bucket.name] = total;
        }, this);
        return result;
    }
});

PJQ.collections.commitments.ChangeOrderHistory = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.commitments.ChangeOrderLineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderLineItem,
    endpoint: function () {
        let params = [];
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'lineitems'
            }
        ], params);
    }
});

PJQ.collections.commitments.ChangeOrderAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders',
                value: this.options.changeOrderId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.commitments.ChangeOrderCustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderCustomField,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'commitmentchangeorders'
                },
                {
                    endpoint: 'customfields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitmentchangeorders'
            },
            {
                endpoint: 'customfields'
            }
        ]);
    }
});

PJQ.collections.commitments.ChangeOrderFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.commitments.ChangeOrderFieldSetting,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'settings'
                },
                {
                    endpoint: 'fields',
                    value: 'commitmentchangeorders'
                }
            ]);

        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'commitmentchangeorders'
            }
        ]);
    }
});
